import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type {
  ChannelStylesheetResponseDto,
  GenerateChannelStylesheetArgs,
  GeneratedChannelStylesheet,
} from './channel-stylesheets.api.types';
import { fromApiChannelStylesheet, toApiChannelStylesheetUrl } from './channel-stylesheets.mapper';

// feedback-web and the chatbot app generate a legacy channel's stylesheets from its primary color. Both are public,
// so no identity is sent.
export const ChannelStylesheetsService = createApi({
  reducerPath: 'ChannelStylesheetsService',
  baseQuery: fetchBaseQuery({ credentials: 'omit', timeout: 10000 }),
  endpoints: (builder) => ({
    generateChannelStylesheet: builder.mutation<GeneratedChannelStylesheet, GenerateChannelStylesheetArgs>({
      query: (args) => ({ url: toApiChannelStylesheetUrl(args) }),
      transformResponse: (response: ChannelStylesheetResponseDto) => fromApiChannelStylesheet(response),
    }),
  }),
});

export const { useGenerateChannelStylesheetMutation } = ChannelStylesheetsService;
